// import Utility from '@/vue/utility/utility';
import Utility from "../js/utility";

// initial state
// shape: [{ id, quantity }]
const state = {
  data: [],
};

// getters
const getters = {
  find(state, getters, rootState, rootGetters) {
    return (id) => {
      return state.data.find(model => model.id === parseInt(id));
    };
  },
  data(state, getters, rootState, rootGetters) {
    return state.data;
  },
};

// actions
const actions = {
  // dummy_action ({state, commit, dispatch, getters, rootState}, payload) {
  //     //
  // }
};

// mutations
const mutations = {
  set_state(state, payload) {
    state[payload.property] = payload.value;
  },
  update_state (state, payload) {
    Object.keys(payload.value).forEach(key => {
      // Update the specific key of the specific property here
      // Vue.set(state[payload.property], key, payload.value[key]);

      state[payload.property] = { ...state[payload.property], [key]: payload.value[key] }

    });
  },
  add_to_data_bulk(state, payload) {
    let new_models = payload.data;

    let new_data = Utility.deep_clone(state.data);

    if(typeof payload.push !== 'undefined' && payload.push) {
      state.data = new_data.concat(new_models);
    }
    else {
      state.data = new_models.concat(new_data);
    }
  },
  add_to_data(state, payload) {
    let new_model = payload.data;
    new_model = Utility.deep_clone(new_model);
    if (state.data === null) {
      state.data = [new_model];
      return;
    }
    if (new_model === null) {
      return;
    }

    let new_data = Utility.deep_clone(state.data);


    // If an model with that ID already exists, we just replace it
    let existing_index = Utility.find_index_of_matching_element(new_data, 'id', new_model.id)


    if (existing_index > -1) {
      new_data[existing_index] = new_model;
    }
    // If not, we add it to the top.
    else {
      if(typeof payload.push !== 'undefined' && payload.push) {
        new_data.push(new_model);
      }
      else {
        new_data.unshift(new_model);
      }
    }
    state.data = new_data;
  },
  /**
   * @param state
   * @param payload object Moet de id field bevatten, id_column en delay optioneel
   */
  remove_from_data(state, payload) {
    let id = payload.id;
    let id_column = 'id';
    if(typeof payload.id_column !== 'undefined') {
      id_column = payload.id_column;
    }
    let delay = 50;
    if(typeof payload.delay !== 'undefined') {
      delay = payload.delay;
    }

    // If a model with that ID exists, we find and remove it
    let indexToRemove = Utility.find_index_of_matching_element(state.data, id_column, id);

    // Met deze delay er in kunnen we bestaande DOM elementen sluiten nadat de commit
    // voltooid is om zo render errors te voorkomen. Als je het direct doet, gaan
    // dingen stuk omdat het model dan ineens niet meer bestaat
    setTimeout(() => {
      state.data.splice(indexToRemove, 1);
    }, delay)
  },
  update_model(state, payload) {
    let model = state.data.find(model => model.id === payload.id);
    model[payload.property] = payload.value;
  },
  clear(state) {
    state.data = [];
  }
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
